import { SINGULAR_DO_NIVEL } from '../applications/textosDoNivel';
import type { NivelDeAplicacao } from '../../types/nivelDeAplicacao';

const ARTIGO_DO_NIVEL: Record<NivelDeAplicacao, 'o' | 'a'> = {
  company: 'a',
  unit: 'a',
  department: 'o',
  occupation: 'o',
  employee: 'o',
};

const CONTRACAO = {
  '': { o: 'o', a: 'a' },
  a: { o: 'ao', a: 'à' },
  de: { o: 'do', a: 'da' },
  em: { o: 'no', a: 'na' },
} as const;

/** "ao cargo Soldador", "da empresa MetalSP", "no setor Produção". */
export function referencia(preposicao: keyof typeof CONTRACAO, nivel: NivelDeAplicacao, nome: string): string {
  return `${CONTRACAO[preposicao][ARTIGO_DO_NIVEL[nivel]]} ${SINGULAR_DO_NIVEL[nivel]} ${nome}`;
}

/** "o Soldador", "no Soldador", "da MetalSP": o nome com o artigo do nível, sem dizer o nível. */
export function referenciaCurta(preposicao: keyof typeof CONTRACAO, nivel: NivelDeAplicacao, nome: string): string {
  return `${CONTRACAO[preposicao][ARTIGO_DO_NIVEL[nivel]]} ${nome}`;
}

/** "o setor", "a empresa": o nível com o artigo, como na frase "voltar a seguir o setor". */
export function oNivel(nivel: NivelDeAplicacao): string {
  return `${ARTIGO_DO_NIVEL[nivel]} ${SINGULAR_DO_NIVEL[nivel]}`;
}
